<!-- Mobile View -->
<div *ngIf="isMobileDevice">
    <div class="image-container overflow-hidden" *ngIf="currentLeadCaptureScreen !== LEAD_CAPTURE_SCREEN.SUCCESS">
        <div class="webcam-container position-relative w-100 h-100">
            <!-- Error shown when user camera is not accessible -->
            <div class="error-modal bg-light position-absolute start-50 translate-middle p-4 rounded-3" *ngIf="errorCamera">
                <div>
                    <div class="d-flex align-items-center">
                        <img
                            src="assets/img/dbc-onboard-v2/exclamation-message.svg"
                            alt="error triangle exclamation"
                            class="error-icon"
                        />
                        <span class="pl-3 mb-0 err-camera-title">Access Denied</span>
                    </div>
                    <p class="mt-3">
                        Enable camera permissions from your browser settings to proceed.
                    </p>
                    <button class="btn btn-transparent dismiss-btn w-100" (click)="closeImageCaptureScreen('closeScreen')">
                        Dismiss
                    </button>
                </div>
            </div>

            <!-- Capture state screen - WEBCAM -->
            <div class="position-relative mobile-image-capture" *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.CAPTURE">
                <video
                    class="w-100 h-100"
                    #videoElement
                    autoplay
                    playsinline
                ></video>
                <div
                    class="position-absolute top-0 start-0 h-100 w-100 capture-frame-outside"
                ></div>
                <div
                    class="position-absolute capture-frame-square start-50 translate-middle"
                >
                    <div class="border border-2 border-light w-100 h-100"></div>
                    <p class="mt-3 mb-0 text-center text-light">
                        Position your card inside the frame
                    </p>
                </div>
            </div>

            <!-- This will be shown when the user clicks on the capture button. It will trigger the animation -->
            <div
                *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.PARSING"
            >
                <img
                    [src]="tempCaptureImage"
                    class="image-capture-flash"
                    alt="result capture img"
                />
            </div>
        </div>

        <!-- Capture state screen - Camera Navigation and control -->
        <div
            class="w-100 d-flex justify-content-around align-items-center image-stream-button-panel"
            [ngClass]="{
                '': currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.CAPTURE,
                'd-none': currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.PARSING,
            }"
        >
            <div>
                <label for="file-upload">
                    <img
                        src="../../../assets/img/dbc-onboard-v2/folder-image.svg"
                        alt="Upload"
                        class="upload-icon"
                    />
                </label>
                <input id="file-upload" type="file" accept="image/*" (change)="handleUploadImageFromStorage($event)" hidden />
            </div>

            <button
                class="bg-light rounded-circle border-0 capture-button"
                [disabled]="loadingCamera"
                (click)="captureImage()"
            ></button>

            <button
                class="btn btn-transparent border-0 text-light p-0"
                [ngClass]="{
                    'opacity-0': isiOS,
                }"
                [disabled]="loadingCamera && isiOS"
                (click)="handleFlashToggle()"
            >
                <img
                    [src]="flashLight ? 'assets/img/dbc-onboard-v2/flash-enable.svg' : 'assets/img/dbc-onboard-v2/flash-disable.svg'"
                    alt="Upload"
                    class="flash-icon"
                />
            </button>
        </div>
        <canvas #canvas class="d-none"></canvas>
    </div>

    <!-- Enable/Disable - Add contact screen -->
    <div *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.SUCCESS">
        <app-image-capture-create-card
            [isMobileDevice]="isMobileDevice"
            [capturedImage]="capturedImage"
            (closeScreen)="closeImageCaptureScreen($event)"
            (summarizeDataEmitter)="onSummarizeDataRecive($event)"
            (onScanErrorEmitter)="onScanError()"
        ></app-image-capture-create-card>
    </div>
</div>

<!-- Desktop View -->
<div *ngIf="!isMobileDevice">
    <div class="modal-container">
        <div class="modal-content">
            <button class="btn-back" (click)="handleDesktopBackCta()">
                <img src="assets/img/dbc-onboard-v2/arrow-left.svg" />
                Back
            </button>
            <ng-container *ngIf="currentLeadCaptureScreen !== LEAD_CAPTURE_SCREEN.SUCCESS">
                <div class="image-container overflow-hidden">
                    <div class="webcam-container position-relative w-100 h-100">

                        <div *ngIf="errorCamera" class="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
                            <div class="no-camera-error">
                                <img class="err-triangle" src="assets/img/dbc-onboard-v2/error-triangle-exclamation.svg" />
                                <span class="text-white">No camera found</span>
                            </div>
                            <p class="text-white mt-3">Enable camera permissions from your browser settings to proceed.</p>
                        </div>

                        <!-- Capture state screen - WEBCAM -->
                        <div class="position-relative w-100 h-100" *ngIf="!errorCamera && (currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.CAPTURE)">
                            <video
                                class="w-100 h-100"
                                #videoElement
                                autoplay
                                playsinline
                            ></video>
                            <div class="position-absolute top-0 start-0 h-100 w-100 capture-frame-outside"></div>
                            <div class="position-absolute capture-frame-desktop-square start-50 translate-middle">
                                <p class="mt-3 mb-0 text-center text-light instruction-text">
                                    Position your card inside the frame and hit <img src="assets/img/dbc-onboard-v2/curve-arrow-left.svg"> Enter to capture.
                                </p>
                                <div class="border border-2 border-light w-100 h-100"></div>
                                <div class="capture-btn cursor-pointer" (click)="captureImage()">
                                    <div class="camera-container">
                                        <img src="assets/img/dbc-onboard-v2/camera-photography.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- This will be shown when the user clicks on the capture button. It will trigger the animation -->
                    <div
                        *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.PARSING"
                    >
                        <img
                            [src]="tempCaptureImage"
                            class="image-capture-flash-desktop"
                            alt="result capture img"
                        />
                    </div>
                </div>
                <canvas #canvas class="d-none"></canvas>
                </div>
            </ng-container>
            <div *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.SUCCESS" class="img-processing-container">
                <app-image-capture-create-card
                    [isMobileDevice]="isMobileDevice"
                    [capturedImage]="capturedImage"
                    (closeScreen)="closeImageCaptureScreen($event)"
                    (summarizeDataEmitter)="onSummarizeDataRecive($event)"
                    (onScanErrorEmitter)="onScanError()"
                ></app-image-capture-create-card>
            </div>

            <span class="seperator">OR</span>


            <div class="btn-upload cursor-pointer" (click)="captureDesktopImage()">
                <img src="assets/img/dbc-onboard-v2/upload-arrow-tray.svg" />
                Upload Photo
            </div>
            <input id="file-upload-desktop" type="file" accept="image/*" (change)="handleUploadImageFromStorage($event)" hidden />

        </div>
    </div>
</div>
